import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** Feature #187: native tooltip shown on hover over the subtitle. */
  subtitleTitle?: string;
  actions?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, subtitleTitle, actions }) => {
  const containerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: '24px 20px',
    borderBottom: '1px solid var(--color-light-grey)',
    backgroundColor: 'var(--color-white)',
    gap: '20px',
  };

  const leftStyle: React.CSSProperties = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  };

  const titleStyle: React.CSSProperties = {
    fontSize: '28px',
    fontWeight: 700,
    fontFamily: 'var(--font-family)',
    color: 'var(--color-black)',
    margin: 0,
  };

  const subtitleStyle: React.CSSProperties = {
    fontSize: '14px',
    fontFamily: 'var(--font-family)',
    color: 'var(--color-dark-grey)',
    margin: 0,
  };

  const actionsStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
  };

  return (
    <div style={containerStyle}>
      <div style={leftStyle}>
        <h1 style={titleStyle}>{title}</h1>
        {subtitle && <p style={subtitleStyle} title={subtitleTitle}>{subtitle}</p>}
      </div>
      {actions && <div style={actionsStyle}>{actions}</div>}
    </div>
  );
};
